<template>
  <MasterLayout page_title="لیست فایل های کاربر">
    <Card>
      <LocalDataTable ajax-link="UserFile/List" :columns="columns"></LocalDataTable>
    </Card>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import LocalDataTable from "@/components/LocalDataTable";
import Card from "@/components/forms/Card";
export default {
name: "UserFileList",
  components: {Card, LocalDataTable, MasterLayout},
  data()
  {
    return{
      columns : [{title : 'عنوان'},{title: 'مربوط به'},{title :'امکانات'}]
    }
  }
}
</script>

<style scoped>

</style>